/**
 * `router/concept.js`
 *  - conceptページのスクリプト
 *
 * 使用方法:
 * - import {initConceptRoutes} from "../router/concept.js";
 */


export const conceptRouter = (data) => {
  console.log("📖 Initializing concept page...");
}
